export const constants = {
    MIN_MOBILE_MONEY_AMOUNT: 500,
    MOBILE_MONEY_AMOUNT_STEP: 500,
    MOBILE_MONEY_AMOUNT_ERROR_DELAY_MS: 1000,
    NETWORK_REQUEST_TIMEOUT: 20, // in seconds
    HIDE_NAVBAR: 'HIDE_FULL',
    HIDE_PART_NAVBAR: 'HIDE_NAV',
    SHOW_NAVBAR: 'SHOW_FULL',
    MALI: 'CFA',
    SENEGAL: 'CFA',
    "COTE D'IVOIRE": 'CFA',
    TANZANIA: 'TZS',
    USER_LOGIN_TIMESTAMP: 'user_login_timestamp',
    endpoints: {
        LOGIN: '/login/',
        GOOGLE_LOGIN: '/google-login/',
        VE_CARD_INVENTORY: '/ve-card-inventory/',
        VES: '/ves/',
        ASSIGNED_VILLAGES: '/assigned-villages/',
        ZONE_VILLAGES: '/zone-villages/',
        ENROLLMENT: '/enrollment/',
        VE_DEPOSIT: '/ve-deposits/',
        ALL_CLIENT_LIST: '/all-client-list/',
        COUNTRY_CONFIG: '/country-config/',
        PERMISSIONS: '/permissions/',
        CLIENT_ORDERS: '/client-orders/',
        ORDERS: '/orders/',
        CLIENT_DETAILS: '/clients/',
        PHONE_LOOKUP: '/clients/phone-lookup/',
        VISIT: '/visit/',
        VE_CARD_PAYMENT: '/payments/',
        TRANSACTIONS: '/transactions/',
        INTERACTIONS: '/interactions/',
        TARGET_LIST: '/target-list/',
        NOTIFICATIONS: '/notifications/',
        FC_METRICS: 'fc/metrics/',
        METABASE_EMBED_TOKEN: 'metabase-embed-token/',
        MOBILE_PAYMENT: '/mobile-money-payment/',
        MOBILE_PAYMENT_CONFIRMATION:
            '/mobile_payment_confirmation/payment/client'
    },
    MOBILE_PAYMENT_SPINNER_TIMEOUT_IN_MS:
        Number(process.env.REACT_APP_MOBILE_PAYMENT_POLLING_DURATION_IN_MS) ||
        60000,
    MOBILE_PAYMENT_POLLING_INTERVAL_IN_MS:
        Number(process.env.REACT_APP_MOBILE_PAYMENT_POLLING_INTERVAL_IN_MS) ||
        10000,
    PAGINATION_BATCH_SIZE: 400,
    USER_PERMISSIONS: 'user_permissions',
    CLIENT_DETAIL_LOCAL_STORE: 'client_details',
    CLIENT_FOR_ENROLLMENT_STORE: 'client_for_enrollment',
    GPS_COORDINATES: 'gps_coordinates',
    COUNTRY_CODE: {
        SENEGAL: 'SN',
        MALI: 'ML',
        TANZANIA: 'TZ'
    },
    MOBILE_SIZE: 540,
    TABLET_SIZE: 768,
    ENROLLMENT_FORM_CACHED_NAME: 'enrollment-form-cached',
    CLIENT_LIST_EXPIRATION_NAME: 'client-list-expiration',
    CLIENT_LIST_EXPIRATION_DURATION: 1,
    TRANSACTIONS_EXPIRATION_NAME: 'transactions-expiration',
    TRANSACTIONS_EXPIRATION_DURATION: 1,
    INTERACTIONS_EXPIRATION_NAME: 'interactions-expiration',
    INTERACTIONS_EXPIRATION_DURATION: 1,
    // Bump the suffix when the cached VEs payload shape changes so every client refetches.
    VES_EXPIRATION_NAME: 'ves-expiration-v2',
    VES_EXPIRATION_DURATION: 10,
    ASSIGNED_VILLAGES_EXPIRATION_NAME: 'assigned-villages-expiration',
    ASSIGNED_VILLAGES_EXPIRATION_DURATION: 10,
    CLIENT_TYPES: {
        PREVIOUS_CLIENT: 'previous_client',
        CURRENT_CLIENT: 'current_client',
        ALL_CLIENT: 'all_client'
    },
    ANIMATION_TIMEOUT: 700,
    VILLAGE_PAGE_TABS: {
        PREVIOUS_CLIENT_TAB: 0,
        CURRENT_CLIENT_TAB: 1
    },
    SORT_TYPE: {
        DATE: 'date',
        ALPHA_NUMERIC: 'alpha_numeric'
    },
    SORT_DIRECTION: {
        ASCENDING: 'ascending',
        DESCENDING: 'descending'
    },
    RANKING_OPTIONS: {
        NUMBER_OF_ENROLLMENTS: 'NUMBER_OF_ENROLLMENTS',
        VALUE_OF_PAYMENTS: 'VALUE_OF_PAYMENTS',
        ENROLLMENT_PROGRESS: 'ENROLLMENT_PROGRESS',
        PAYMENT_PROGRESS: 'PAYMENT_PROGRESS'
    },
    PAYMENT_OPTIONS: {
        MOBILE_MONEY: 'Mobile money',
        SCRATCH_CARD: 'Scratch card'
    },
    MOBILE_MONEY: {
        WAVE: 'WAVE',
        ORANGE_USSD: 'ORANGE_USSD',
        ORANGE_MONEY: 'ORANGE',
        SUCCESS: 'success',
        FAILURE: 'failure',
        PENDING: 'pending'
    },
    CLIENT_SORT_OPTIONS: {
        REMAINING_PAYMENT: 'REMAINING_PAYMENT',
        COLOR_CODING: 'COLOR_CODING'
    },
    VIEW_PAYMENTS: 'view_payments',
    VIEW_VILLAGES: 'view_villages',
    VIEW_FINISHERS: 'view_finishers',
    UPDATE_ORDER: 'update_order',
    UPDATE_CLIENT: 'update_client',
    CONNECT_USER: 'connect_user',
    COUNTRY_CONFIG: 'country_config',
    CLIENT_FOR_VISIT_STORE: 'client_for_visit',
    CLIENT_VISIT_INTERACTION: 'client_visit_interaction',
    LAST_VISITED_CLIENT_CODE: 'last_visited_client_code',
    fcSearchResults: 'FC_SEARCH_RESULTS',
    CAN_RECORD_HOME_VISIT: 'can_record_home_visit',
    CAN_RECORD_HOME_VISIT_ENROLLMENT: 'can_record_home_visit_new_client',
    CAN_VIEW_LOGO_BUTTON: 'can_view_logo_button',
    CAN_VIEW_TARGET_LIST: 'can_view_target_list',
    CAN_USE_FARMER_ID: 'can_use_farmer_id',
    CAN_VIEW_REFERRALS_ENROLLMENT_FLOW: 'can_view_referrals_enrollment_flow',
    CAN_MAKE_CARD_PAYMENT: 'can_make_card_payment',
    CAN_RECORD_INTERACTIONS: 'can_record_interactions',
    CAN_VIEW_VILLAGE_PAGE_REDESIGN: 'can_view_village_page_redesign',
    CAN_USE_WEBSOCKETS: 'can_use_websockets',
    CAN_MAKE_MOBILE_PAYMENT: 'can_make_mobile_payment',
    CAN_SEE_DUPLICATE_PHONE: 'can_see_duplicate_phone',
    CAN_VIEW_ENROLLMENT_QR: 'can_view_enrollment_qr',
    CAN_VIEW_BULK_ENROLLMENT: 'can_view_bulk_enrollment',
    ANALYTICS: {
        CATEGORIES: {
            PAYMENT: 'payment',
            BULK_ENROLLMENT: 'bulk enrollment'
        },
        ACTIONS: {
            FILTER_LIST: 'filter list',
            SEARCH: 'client search',
            ENROLLMENT: 'enrollment',
            ENROLLMENT_PACKAGE_CHOICE: 'enrollment package choice',
            CARD_PAYMENT: 'card payment',
            MOBILE_MONEY_PAYMENT: 'mobile money payment',
            TARGET_LIST_SEARCH: 'target list search',
            TARGET_LIST_FILTER: 'target list filter',
            PHONE_CALL: 'phone call',
            SWIPED: 'swiped',
            BULK_ENROLLMENT_STARTED: 'bulk enrollment started',
            BULK_ENROLLMENT_COMPLETED: 'bulk enrollment completed',
            BULK_ENROLLMENT_ABANDONED: 'bulk enrollment abandoned',
            BULK_ROW_CONFIRMED: 'bulk row confirmed',
            BULK_ROW_REMOVED: 'bulk row removed',
            BULK_ROW_VALIDATION_ERROR: 'bulk row validation error',
            BULK_NAME_CORRECTED: 'bulk name corrected',
            BULK_PACKAGE_QUANTITY_CHANGED: 'bulk package quantity changed',
            BULK_BATCH_SUBMITTED: 'bulk batch submitted',
            PHONE_LOOKUP: 'phone lookup'
        },
        NAMES: {
            PAYMENT_START: 'payment start',
            PAYMENT_SUCCESS: 'payment success',
            TARGET_LIST_SEARCH_INITIATED: 'Target List Search Initiated',
            PAYMENT_FAILURE: 'payment failure',
            PAYMENT_EXITED: 'payment_exit',
            BULK_EXIT: 'bulk_exit',
            PACKAGE_CHOICE_ADD: 'add_packages',
            PACKAGE_CHOICE_WITHOUT: 'without_packages',
            ENROLLMENT_EXIT: 'exit',
            PHONE_LOOKUP_OPENED_EXISTING: 'opened_existing',
            PHONE_LOOKUP_OPENED_EXISTING_LOCAL: 'opened_existing_local',
            PHONE_LOOKUP_CONTINUED: 'continued_anyway',
            PHONE_LOOKUP_CONTINUED_LOCAL: 'continued_anyway_local',
            PHONE_LOOKUP_OFFLINE: 'offline_skip',
            PHONE_LOOKUP_NO_MATCH: 'no_match'
        },
        COMPLETED: 'completed',
        COMPLETED_WITHOUT_PAYMENT: 'completed without payment',
        ABANDONED: 'abandoned',
        STARTED: 'started',
        CLIENT_DETAILS: 'client details',
        CLIENT_PACKAGE: 'client package',
        VILLAGE_CLIENT: 'village current clients',
        VILLAGE_POTENTIAL: 'village potential clients',
        FILTER_DIMENSION: 1,
        ALL: 'All',
        FC_VIEW_VE_PROFILE: 'fc view ve profile',
        TIME_TO_VIEW_PAGE: 'time to view page',
        SEARCHES: 'searches',
        FC_SEARCHES: 'fc searches',
        TARGET_LIST: 'target list',
        VILLAGE_PAGE: 'village page',
        VE_PROFILE: {
            MY_SALES: 'my sales',
            VE_PROFILE: 've_profile',
            VE_PROFILE_VIEWED: 've_profile_viewed',
            VE_PROFILE_ACTION: 've profile viewed',
            VE_CALCULATOR_ACTION: 've calculator action',
            VE_CALCULATOR_VIEWED: 've_profile_calculator_viewed',
            VE_ACTIVE_FARMER_OPENED_ACTION: 've active farmers opened',
            VE_ACTIVE_FARMER_OPENED_OPENED: 've_profile_active_farmers_opened',
            VE_ENROLLED_FARMER_OPENED_ACTION: 've enrolled farmers opened',
            VE_ENROLLED_FARMER_OPENED_OPENED:
                've_profile_enrolled_farmers_opened',
            VE_CARD_INVENTORY_VIEWED: 've_profile_card_inventory_viewed',
            VE_CARD_INVENTORY_ACTION: 've card inventory viewed',
            VE_DEPOSIT_OPENED: 've_profile_deposits_opened',
            VE_DEPOSIT_ACTION: 've deposits opened',
            VE_ENROLLMENT_WITHOUT_PAYMENT_ACTION:
                've enrollment without payment opened',
            VE_ENROLLMENT_WITHOUT_PAYMENT_OPENED:
                've_profile_enrollment_without_payment_opened',
            VE_OLD_VISIT_ACTION: 've old visits opened',
            VE_OLD_VISIT_OPENED: 've_profile_old_visits_opened',
            VE_NEW_VISIT_ACTION: 've new visits opened',
            VE_NEW_VISIT_OPENED: 've_profile_new_visits_opened'
        }
    },
    ORIGIN_ENROLLMENT: 'enrollment',
    ORIGIN_CLIENT_DETAIL: 'client_detail',
    ORIGIN_PREV_CLIENT_DETAIL: 'prev_client_detail',
    SEARCH_RESULT: 'search result',
    ITEMS_PER_LOAD: 30,
    DEFAULT_FEEDBACK_MODAL_DURATION: 10000,
    PACKAGE_ENROLLMENT: 'package_enrollment',
    INTERACTION_STORE_KEY: 'interaction_location',
    TARGET_LIST_FILTERS: {
        ALL: 'all',
        VISITED: 'visited',
        NOT_VISITED: 'not_visited'
    },
    PERFORMANCE_COLORS: {
        LOW: 'low',
        MEDIUM: 'medium',
        HIGH: 'high'
    },
    FORM_TYPES: {
        ENROLLMENT: 'enrollment',
        MODIFICATION: 'modification',
        RE_ENROLLMENT: 're-enrollment'
    },
    TARGET_LIST_SURVEY_NAME:
        process.env.REACT_APP_TARGET_LIST_SURVEY_NAME || 'Target List',
    TARGET_LIST_SURVEY_VERSION:
        process.env.REACT_APP_TARGET_LIST_SURVEY_VERSION || '1.0',
    FARMER_AWARENESS_SURVEY_NAME:
        process.env.REACT_APP_AWERNESS_SURVEY_NAME || 'Awareness Survey',
    FARMER_AWARENESS_SURVEY_VERSION:
        process.env.REACT_APP_AWERNESS_SURVEY_VERSION || '0.2',
    PACKAGE_MODIFICATION_SURVEY_NAME:
        process.env.REACT_APP_PACKAGE_MODIFICATION_SURVEY_NAME ||
        'Package Modification',
    PACKAGE_MODIFICATION_SURVEY_VERSION:
        process.env.REACT_APP_PACKAGE_MODIFICATION_SURVEY_VERSION || '1.0',
    PACKAGE_ENROLLMENT_SURVEY_NAME:
        process.env.REACT_APP_PACKAGE_ENROLLMENT_SURVEY_NAME ||
        'Package Enrollment',
    PACKAGE_ENROLLMENT_SURVEY_VERSION:
        process.env.REACT_APP_PACKAGE_ENROLLMENT_SURVEY_VERSION || '1.0',
    BULK_ENROLLMENT_SURVEY_NAME: 'Bulk Enrollment',
    BULK_ENROLLMENT_SURVEY_VERSION: '1.0',

    CLIENT_REGISTRATION_SURVEY_NAME: 'Client Registration',
    CLIENT_REGISTRATION_SURVEY_VERSION: '1.0',
    MAX_ORDER_OF_PACKAGE: 20,
    VOUCHER_CODE_LENGTH: 14,
    PAYMENT_SOURCES: {
        MANUAL: 'manual',
        QR_CODE: 'qr_code'
    },
    CLIENT_MODIFICATION_TYPES: {
        DETAILS: 'client_details',
        PACKAGES: 'packages'
    },
    MESSAGES: {
        GET_VES: 'get ves',
        STORE_VES: 'store ves',
        GET_ASSIGNED_VILLAGES: 'get assigned villages',
        STORE_ASSIGNED_VILLAGES: 'store assigned villages',
        GET_VE: 'get ve',
        STORE_VE_DEPOSIT: 'store ve deposit',
        GET_VE_DEPOSIT: 'get ve deposit',
        UPDATE_PAYMENT_CELEBRATION_STORE: 'update payment celebration store',
        GET_PAYMENT_CELEBRATION_STORE: 'get payment celebration store',
        STORE_PRODUCT_CATEGORY: 'store_product_category',
        GET_PRODUCT_CATEGORY: 'get_product_category',
        GET_PRODUCT_CATEGORIES: 'get_product_categories',
        GET_CLIENTS: 'get client data'
    },
    NOTIFICATIONS: {
        TYPES: {
            REMINDER: 'REMINDER'
        },
        SUB_TYPES: {
            PAYMENT: 'PAYMENT',
            DEPOSIT: 'DEPOSIT'
        }
    },
    SERVICE_WORKER_UPDATE_KEY: 'serviceWorkerUpdate',
    VISITED_GIF_DURATION_IN_MS: 8000,
    visitedOutcomes: {
        ENROLL: 'ENROLL',
        ENROLLED: 'ENROLLED',
        FOLLOW_UP: 'FOLLOW_UP',
        REIMBURSEMENT_REQUESTED: 'REIMBURSEMENT_REQUESTED',
        CARD_PAYMENT: 'CARD_PAYMENT',
        MOBILE_MONEY_PAYMENT: 'MOBILE_MONEY_PAYMENT'
    },
    PING_MESSAGE: 'connect-v2',
    PONG_RESPONSE: 'pong',
    OFFLINE: 'Offline',
    TIME_OUT: 'Timeout'
}

export const routes = {
    enroll: 'enroll',
    packages: {
        index: 'packages',
        selectSize: 'select-size'
    },
    selectPayment: 'payment-selection',
    cardDetails: 'card-details',
    clientDetails: 'client-details',
    clientDetailsSteps: {
        stepOne: 'step-1',
        stepTwo: 'step-2',
        stepThree: 'step-3'
    }
}

export const permissionFlags = {
    canUseFarmerId: 'can_use_farmer_id'
}

export const STAFF_ROLES = {
    VE: 'VE',
    FC: 'FC',
    POULTRY_AGENT: 'poultry agent',
    FIELD_AGENT: 'field agent'
}

export const ROLES_WITHOUT_BLANK_IDS = [
    STAFF_ROLES.FC,
    STAFF_ROLES.POULTRY_AGENT
]

export enum ENROLLMENT_FLOW_TYPES {
    ENROLLMENT_WITHOUT_PACKAGES = 'enrollment_without_packages',
    ENROLLMENT = 'enrollment',
    ENROLLMENT_WITH_VOUCHER = 'enrollment_with_voucher',
    ENROLLMENT_WITH_MOBILE_MONEY = 'enrollment_with_mobile_money',
    CLIENT_MODIFICATION = 'client_modification',
    REENROLLMENT = 'reenrollment',
    REENROLLMENT_WITH_MOBILE_MONEY = 'reenrollment_with_mobile_money',
    REENROLLMENT_WITH_MOBILE_MONEY_AND_CLIENT_DETAILS = 'reenrollment_with_mobile_money_and_client_details',
    PACKAGE_MODIFICATION = 'package_modification'
}

export enum ENROLLMENT_STEPS {
    PACKAGE_CHOICE = 'package_choice',
    PRODUCT_SELECTION = 'product_selection',
    PACKET_SELECTION = 'packet_selection',
    REGISTERED_PACKAGES = 'registered_packages',
    MOBILE_MONEY_SELECTION = 'mobile_money_selection',
    MOBILE_MONEY_AMOUNT = 'mobile_money_amount',
    AGE = 'age',
    GENDER = 'gender',
    GROUP_ROLE = 'group_role',
    FIRST_NAME = 'first_name',
    LAST_NAME = 'last_name',
    PHONE_NUMBER = 'phone_number',
    REFERRALS = 'referrals'
}

export const ENROLLMENT_FLOW_STEPS: Record<
    ENROLLMENT_FLOW_TYPES,
    ENROLLMENT_STEPS[]
> = {
    [ENROLLMENT_FLOW_TYPES.ENROLLMENT_WITHOUT_PACKAGES]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME,
        ENROLLMENT_STEPS.PHONE_NUMBER
    ],
    [ENROLLMENT_FLOW_TYPES.ENROLLMENT]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES,
        ENROLLMENT_STEPS.REFERRALS,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME,
        ENROLLMENT_STEPS.PHONE_NUMBER
    ],
    [ENROLLMENT_FLOW_TYPES.ENROLLMENT_WITH_VOUCHER]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES,
        ENROLLMENT_STEPS.REFERRALS,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME,
        ENROLLMENT_STEPS.PHONE_NUMBER
    ],
    [ENROLLMENT_FLOW_TYPES.ENROLLMENT_WITH_MOBILE_MONEY]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES,
        ENROLLMENT_STEPS.MOBILE_MONEY_AMOUNT,
        ENROLLMENT_STEPS.MOBILE_MONEY_SELECTION,
        ENROLLMENT_STEPS.REFERRALS,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME,
        ENROLLMENT_STEPS.PHONE_NUMBER
    ],
    [ENROLLMENT_FLOW_TYPES.CLIENT_MODIFICATION]: [
        ENROLLMENT_STEPS.PHONE_NUMBER,
        ENROLLMENT_STEPS.AGE,
        ENROLLMENT_STEPS.GENDER,
        ENROLLMENT_STEPS.GROUP_ROLE,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME
    ],
    [ENROLLMENT_FLOW_TYPES.REENROLLMENT]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES
    ],
    [ENROLLMENT_FLOW_TYPES.REENROLLMENT_WITH_MOBILE_MONEY]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES,
        ENROLLMENT_STEPS.MOBILE_MONEY_AMOUNT,
        ENROLLMENT_STEPS.MOBILE_MONEY_SELECTION
    ],
    [ENROLLMENT_FLOW_TYPES.REENROLLMENT_WITH_MOBILE_MONEY_AND_CLIENT_DETAILS]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES,
        ENROLLMENT_STEPS.MOBILE_MONEY_AMOUNT,
        ENROLLMENT_STEPS.MOBILE_MONEY_SELECTION,
        ENROLLMENT_STEPS.FIRST_NAME,
        ENROLLMENT_STEPS.LAST_NAME,
        ENROLLMENT_STEPS.PHONE_NUMBER
    ],
    [ENROLLMENT_FLOW_TYPES.PACKAGE_MODIFICATION]: [
        ENROLLMENT_STEPS.PRODUCT_SELECTION,
        ENROLLMENT_STEPS.PACKET_SELECTION,
        ENROLLMENT_STEPS.REGISTERED_PACKAGES
    ]
}

export const PRODUCT_CATEGORY = {
    POULTRY: 'poultry',
    CEREAL: 'cereal',
    VEGETABLE: 'vegetable',
    DAP: 'dap'
}

export const WebsocketEndpoints = {
    PING_PONG: 'ping-pong/'
}
